import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import { Rank } from '@ascschool/model/category/rank.model';
import { DegreeService } from '@ascschool/services/category/degree.service';
import { Degree } from '@ascschool/model/category/degree.model';
import { CertificateTakeCareOfStudent } from '@ascschool/model/school/certificate-take-care-of-student.model';
import { CustomResponse } from '@ascschool/model/custom-response.model';
import { StudentLearningProcess } from '@ascschool/model/school/student-learning-process.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CourseService } from '@ascschool/services/school/course.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { ClassCourseCourseService } from '@ascschool/services/category/class-course.service';
import { StaffService } from '@ascschool/services/user/staff.service';
import { ResultService } from '@ascschool/services/category/result.service';
import { AchievementService } from '@ascschool/services/category/achievement.service';
import { ClassService } from '@ascschool/services/category/class.service';
import { DisbilityOfStudent } from '@ascschool/model/school/disbility-of-student.model';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { LevelService } from '@ascschool/services/category/level.service';

@Component({
  selector: 'app-disbility-of-student-add-popup',
  templateUrl: './disbility-of-student-add-popup.component.html',
  styleUrls: ['./disbility-of-student-add-popup.component.scss']
})
export class DisbilityOfStudentAddPopupComponent implements OnInit {
  @Input() schoolId: any;
  @Input() dataTransmission: any;
  itemDis: DisbilityOfStudent = new DisbilityOfStudent();
  response: CustomResponse = new CustomResponse();

  getTypeOfDisabilityACFn: (value: any) => Observable<any>;
  TypeOfDisabilitySubscription: any;
  TypeOfDisabilityControl = new FormControl();
  getLevelACFn: (value: any) => Observable<any>;
  LevelSubscription: any;
  LevelControl = new FormControl();
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,  
    public utilsService: UtilsService, 
    private typeOfDisabilityService: TypeOfDisabilityService,
    private levelService: LevelService,
  ) {
  }

  ngOnInit() {
    if (this.dataTransmission) {
      this.itemDis = Object.assign({}, this.dataTransmission);
      this.TypeOfDisabilityControl.setValue({ id: this.itemDis.typeOfDisabilityId, text: this.itemDis.typeOfDisabilityName });
      this.LevelControl.setValue({ id: this.itemDis.levelId, text: this.itemDis.levelName });
      this.loadTypeOfDisability();
      this.loadLevel();
    }else{
      this.loadTypeOfDisability();
      this.loadLevel();
    }
  }
  loadTypeOfDisability() {
    console.log(this.TypeOfDisabilityControl.value)
    this.getTypeOfDisabilityACFn = (value: any) => this.typeOfDisabilityService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.TypeOfDisabilitySubscription) this.TypeOfDisabilitySubscription = this.TypeOfDisabilityControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemDis, 'typeOfDisabilityId', this.TypeOfDisabilityControl.value);
    });
  }
  changeTypeOfDisability(control: FormControl) {
    this.TypeOfDisabilityControl = control;
  }

  loadLevel() {
    this.getLevelACFn = (value: any) => this.levelService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.levelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.LevelSubscription) this.LevelSubscription = this.LevelControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemDis, 'levelId', this.LevelControl.value);
    });
  }
  changeLevel(control: FormControl) {
    this.LevelControl = control;
  }

  UpdateClose() {
    if (this.itemDis.typeOfDisabilityId && this.itemDis.levelId) {
      this.itemDis.levelName = this.LevelControl.value.text;
      this.itemDis.typeOfDisabilityName = this.TypeOfDisabilityControl.value.text;
      this.response.data = this.itemDis;
      this.response.status = true;
      this.modal.close(this.response);
     
    } else {
      this.msg.warning('Vui lòng nhập trường bắt buộc');
    }
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(this.response);
  }
  
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  onChange(result: Date[]): void {
    console.log('onChange: ', result);
  }
  
}
